import Grid from '@mui/material/Grid';
import { OrderWithItems } from 'common-models';
import { FC, useEffect } from "react";
import PageIsLoading from "src/components/PageIsLoading";
import { useStartSwishPaymentMutation } from '../../../features/events/eventShopApiSlice';
type SwishPaymentInitiatingProps = {
    order: OrderWithItems,
}

const SwishPaymentInitiating: FC<SwishPaymentInitiatingProps> = ({ order }) => {

    const [startSwishPayment] = useStartSwishPaymentMutation();

    useEffect(() => {
        if (order !== undefined && startSwishPayment !== undefined) {
            startSwishPayment({ orderId: order.id });
        }
    }, [order, startSwishPayment])

    return (

        <Grid
            size={{ xs: 12, sm: 12, lg: 4 }}>
            <Grid container>
                Startar Swish-betalning...
            </Grid>
            <Grid container>
                <PageIsLoading />
            </Grid>
        </Grid>
    );
    // }
};

export { SwishPaymentInitiating };
